// extracted by mini-css-extract-plugin
export var background = "_5j-0";
export var container = "_5j-1";
export var contentItem = "_5j-7";
export var extendedWarranty = "_5j-5";
export var link = "_5j-d";
export var modal = "_5j-b";
export var modalCloseButton = "_5j-9";
export var modalContent = "_5j-3";
export var modalContentMain = "_5j-6";
export var modalImageLogo = "_5j-8";
export var modalLogo = "_5j-a";
export var modalSideImage = "_5j-4";
export var preview = "_5j-c";
export var redoModal = "_5j-2";